// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchBar_searchContainer__mklIQ","searchIcon":"SearchBar_searchIcon__EoGGQ","searchInput":"SearchBar_searchInput__oKhdU","clearBtn":"SearchBar_clearBtn__4USYU"};